import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.Drawer.PayMenu', {
    payMenu: 'ApprovalMax Pay',
    wallets: 'Wallets',
    connectedAccounts: 'Connected accounts',
});
